const mappingQty = (value, label, qty_jobmix = 1) => {
    return value[label].map(val => {
        return {
            ...val,
            qty_produksi: val.flag === "UT" ? parseInt(val.base_qty) * parseInt(qty_jobmix) : val.qty_produksi
        }
    })
}

export default mappingQty